import React from 'react';
import { Tag, Input, Tooltip, Icon, message, AutoComplete, Button, Select } from 'antd';
import _ from 'lodash'

import { addTag, updateTag, removeTag } from '../../actions/tags';
import { store } from './../../store'

import { isObject } from './../../util';

const Option = Select.Option;

class QuestionTags extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      tags: _.values(this.props.tags),
      inputVisible: false,
      inputValue: '',
      editIndex: -1,
      editTag: false,
      onStatus: null,
      onStatusVal: null,
      editInputValue: '',
      dataSource: store.getState().tags.slice(0, 500) // Limit render for 500 items for dropdown
    }
    // console.log('all the tags -> ' + JSON.stringify(store.getState().tags.slice(0, 500)))
  }

  handleClose = (removedTag) => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags, onStatus: 'remove', onStatusVal: removedTag });

    let removeIndex = store.getState().tags.findIndex(t => {
      if(!isObject(t)){
        t.toLowerCase() === removedTag.toLowerCase()
      }
    });
    
    // debugger;
    store.dispatch(removeTag(removeIndex))
    
    setTimeout(() => {
      this.handleInputConfirm()
      console.log('store getState(): ' + JSON.stringify(store.getState().tags));
      // debugger;
    },100)
  }

  showInput = () => {
    this.setState({ inputVisible: true, dataSource: store.getState().tags.slice(0, 500) }, () => {
      this.input.focus()
    });
  }

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  }

  handleInputConfirm = (value) => {
    this.setState({
      inputValue: value
    })
    // debugger;
    setTimeout(() => {
      const inputValue = this.state.inputValue;
  
      if(inputValue === "") this.setState({ inputVisible: false, inputValue: '', editTag: false })
      else{
        this.tagFilterExist(inputValue).then((exist) => {
          if(!exist){
            console.log('editTag-> ' + this.state.editTag)
            if(this.state.editTag === true) {
              console.log('i am edit tag!')
              this.setState({ editTag: false, onStatus: 'edit', onStatusVal: inputValue })
              this.confirmInput(true) // Update existing tag with edited tag

              // setTimeout(() => {
              //   this.setState({  })
              // },0)
            }else this.confirmInput(false) // Add new tag         
          }else message.warning("Duplication found tag!"); this.setState({ inputVisible: false, inputValue: '', editTag: false }); 
        })
      }
    },0)
  }

  confirmInput = (editTag) => {
    const state = this.state;
    const inputValue = state.inputValue;
    let tags = state.tags

    console.log('inputValue -> ' + inputValue)
    console.log('tags.indexOf(inputValue) -> ' + tags.indexOf(inputValue))
    // Add Data
    if (inputValue && tags.indexOf(inputValue) === -1) {

      console.log('...editTag -> ' + editTag)
      if(!editTag) tags = [...tags, inputValue]; // Add new tag
      else tags[this.state.editIndex] = inputValue; // replace the existing tag with edited tag
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    });

    if(this.props.onTarget === "answer"){
      const { onStatus, onStatusVal, editInputValue } = this.state;

      var answer = this.props.onAnswer;
      var questionData = _.cloneDeep(this.props.questionData)
      var answersData = _.cloneDeep(JSON.parse(this.props.questionData.answers))
      let targetIndex = answersData.findIndex( x => x.answer === answer);
      answersData[targetIndex]['tags'] = tags;
      questionData['answers'] = answersData

      console.log('questionData, tags, targetIndex -> ', questionData, tags, targetIndex)
      console.log('onStatus, onStatusVal, editInputValue -> ', onStatus, onStatusVal, editInputValue)
      // this.props.onEditQuestionTags(questionData, tags, targetIndex)
      var tagValue = null;
      if (onStatus === 'remove') tagValue = { val: onStatusVal };
      else if (onStatus === 'edit') tagValue = { oldVal: editInputValue, newVal: onStatusVal};
      else tagValue = { val: inputValue }
      
      this.props.onEditQuestionTags(questionData, tagValue, targetIndex, onStatus )

    }else{
      const { onStatus, onStatusVal, editInputValue } = this.state;
      console.log('onStatus ... ' + onStatus);

      var tagValue = null;
      if (onStatus === 'remove') tagValue = { val: onStatusVal };
      else if (onStatus === 'edit') tagValue = { oldVal: editInputValue, newVal: onStatusVal};
      else tagValue = { val: inputValue }
      
      this.props.onEditQuestionTags(this.props.questionData, tagValue, onStatus )
      this.setState({ onStatus: null, onStatusVal: null })
      
    }
  }

  tagFilterExist = (inputValue) => {
    const { tags } = this.state;
    let existingValueFound = tags.filter(value => { return value === inputValue });
    if(existingValueFound.length > 0) return Promise.resolve(true);
    else return Promise.resolve(false);
  }

  onEditTag = (tag, ind) => {
    // var updatedTag = this.state.tags.filter((z) => { return z !== tag })

    this.setState({
      editIndex: ind,
      editInputValue: tag,
      inputValue: tag,
      inputVisible: true,
      editTag: true 
    })

    // update dropdown
    this.handleSearch(tag)
  }

  saveInputRef = input => this.input = input

  handleSearch = (value) => {
    
    var allDataSource = store.getState().tags; // Retrieve entire tagging items
    var possibleMatch = _.filter(allDataSource,
      (s) => {
        if(!isObject(s)) {
          // console.log('s handleSearch: ' + JSON.stringify(s))
          var str = ((s.trim()).length !== 0) ? s.split(' ') : s;
          // console.log('str... ', str)
          // console.log('str.includes(value)... ', str.includes(value))

          let found = str.filter((ss) => { return ss.toLowerCase().indexOf(value.toLowerCase()) === 0 });
          // indexOf -1 is all occurrences match, 0 is first letters occurrence match
          return (s.toLowerCase().indexOf(value.toLowerCase()) === 0 || found.length > 0)
        }else return;
      });

    // console.log('allDataSource: ', allDataSource)
    // console.log('possibleMatch: ', possibleMatch)

    this.setState({
      inputValue: value,
      dataSource: !value ? [] : possibleMatch
    });
  }

  handleInputKey = (e) => {
    if(e && e.keyCode === 13){
      // User pressed enter
      this.handleInputConfirm(this.input.props.value);
    }
  }

  render() {
    const { tags, inputVisible, inputValue, editIndex, editTag, dataSource } = this.state;
    console.log('dataSource? ' + JSON.stringify(dataSource));
    const tagSpaces = dataSource.map(d => <Option key={d}>{d}</Option>);

    return (
      <div>
        {tags.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag 
              className={{ 'hiddenBlock': (editTag && index === editIndex) }}
              key={tag} closable={index !== -1} afterClose={() => this.handleClose(tag)}>
                <Icon onClick={() => this.onEditTag(tag,index) } type="edit" />&nbsp;
                {tag}
            </Tag>
          );
          return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem;
        })}

        
        {inputVisible && (
          <div style={{ width: '50%', display: 'inline-block' }}>
            <Select
              ref={this.saveInputRef}
              mode="combobox"
              value={inputValue}
              placeholder="Type new tag"
              defaultActiveFirstOption={false}
              style={{ width: '100%' }}
              showArrow={false}
              filterOption={false}
              onSelect={this.handleInputConfirm}
              onSearch={this.handleSearch}
              onInputKeyDown={this.handleInputKey}
              // onChange={this.handleInputConfirm}
            >
              {tagSpaces}
            </Select>
          </div>
        )}
        {/* AutoComplete doesn't support keyboard ENTER, make a button instead. */}
        {(inputVisible && dataSource.length === 0) && (
          <Button
            style={{ width: '45%', display: 'inline-block' }}
            onClick={(e) => { this.handleInputConfirm(this.input.props.value); e.preventDefault(); return; } }>
              Add New
          </Button>
        )}
        
        
        
        
        {!inputVisible && (
          <Tag
            onClick={this.showInput}
            style={{ background: '#fff', borderStyle: 'dashed' }}
          >
            <Icon type="plus" /> New Tag
          </Tag>
        )}
      </div>
    );
  }
}

export default QuestionTags


// WEBPACK FOOTER //
// ./src/components/dashboard/questionTags.js